import { render, staticRenderFns } from "./barbearia.vue?vue&type=template&id=6abc035f&scoped=true"
import script from "./barbearia.vue?vue&type=script&lang=js"
export * from "./barbearia.vue?vue&type=script&lang=js"
import style0 from "./barbearia.vue?vue&type=style&index=0&id=6abc035f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abc035f",
  null
  
)

export default component.exports